import { createAction, props } from '@ngrx/store';
import { TenantConfig } from 'brain-data/model/config.model';

export const loadTenantConfig = createAction('[Tenant config] loading');
export const loadTenantConfigSuccess = createAction('[Tenant config] loading success', props<{ tenantConfig: TenantConfig }>());
export const loadTenantConfigError = createAction('[Tenant config] loading error', props<{ error: Error }>());
